import * as React from 'react'
import { Rectangle, RectangleProps } from 'recharts'

import { ChartWrapperContext } from './ChartWrapper'

interface CustomCursorProps extends Partial<Omit<RectangleProps, 'points'>> {
  points?: [{ x: number; y: number }]
}

export function CursorBar({
  numberOfDatapoints,
  points,
  x: givenX,
  y: givenY,
  ...props
}: CustomCursorProps & { numberOfDatapoints: number | null }) {
  const { isTooltipActive } = React.useContext(ChartWrapperContext)

  if (!isTooltipActive) return null

  const cursorWidth = numberOfDatapoints ? props.width! / numberOfDatapoints : props.width!
  const x = givenX ?? points![0].x - cursorWidth / 2
  const y = givenY ?? points![0].y
  return (
    <Rectangle
      {...props}
      x={x}
      y={y}
      width={cursorWidth}
      className="fill-gray-50/65 stroke-none dark:fill-gray-700/65"
    />
  )
}

export function CursorLine({ points, x: givenX, y: givenY, ...props }: CustomCursorProps) {
  const { isTooltipActive } = React.useContext(ChartWrapperContext)

  if (!isTooltipActive) return null

  const x = givenX ?? points![0].x - 1
  const y = givenY ?? points![0].y
  return <Rectangle {...props} x={x} y={y} width={1} className="fill-gray-500 stroke-none dark:fill-gray-300" />
}
